import { render } from "./OrganizationCreator.vue?vue&type=template&id=7c64b049"
import script from "./OrganizationCreator.vue?vue&type=script&lang=js"
export * from "./OrganizationCreator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__